/* TASKS */
export const GET_PRIZES = "GET_PRIZES"
export const GET_PRIZES_SUCCESS = "GET_PRIZES_SUCCESS"
export const GET_PRIZES_FAIL = "GET_PRIZES_FAIL"
export const GET_REDEMPTIONS_ACTIVITY = "GET_REDEMPTIONS_ACTIVITY"
export const GET_REDEMPTIONS_ACTIVITY_SUCCESS = "GET_REDEMPTIONS_ACTIVITY_SUCCESS"
export const GET_REDEMPTIONS_ACTIVITY_FAIL = "GET_REDEMPTIONS_ACTIVITY_FAIL"
export const ADD_REDEMPTION = "ADD_REDEMPTION"
export const ADD_REDEMPTION_SUCCESS = "ADD_REDEMPTION_SUCCESS"
export const ADD_REDEMPTION_FAIL = "ADD_REDEMPTION_FAIL"
export const UPDATE_REDEMPTION = "UPDATE_REDEMPTION"
export const UPDATE_REDEMPTION_SUCCESS = "UPDATE_REDEMPTION_SUCCESS"
export const UPDATE_REDEMPTION_FAIL = "UPDATE_REDEMPTION_FAIL"
export const ADD_ACTIVITY = "ADD_ACTIVITY"
export const ADD_ACTIVITY_SUCCESS = "ADD_ACTIVITY_SUCCESS"
export const ADD_ACTIVITY_FAIL = "ADD_ACTIVITY_FAIL"

